import {useLoginStore, useSpaAsyncConfig} from '../../../context';

export const useUtilityNavigationItems = () => {
    const {utilityNavItems, utilityNavItemsCommercial} =
        useSpaAsyncConfig().utilityNavigationModel;
    const loggedIn = useLoginStore().isLoggedIn;
    const isPrivateUser = useLoginStore().customerType === 'private';

    if (loggedIn) {
        const commercialItems = utilityNavItemsCommercial
            ? utilityNavItemsCommercial
            : [];
        return {
            activeItems: isPrivateUser ? utilityNavItems : commercialItems,
            inactiveItems: []
        };
    }
    const activeItems = utilityNavItems.filter(i => !i.loginRequired);
    const inactiveItems = utilityNavItems.filter(i => i.loginRequired);
    return {activeItems, inactiveItems};
};
